module.exports = __webpack_public_path__ + "img/bg-mobile.844db4b.jpg";